import {trigger} from "../../../utils/events/trigger";
import {initWindow} from "./window";
import {initAsideSidebar} from "./aside.sidebar";
import {MEDIA} from "../../constants";

export const initResize = () => {
	window.addEventListener(`resize`, (evt) => {
		initWindow();
		initAsideSidebar();

		if (window.innerWidth >= MEDIA.DESKTOP && (document.querySelector(`#sidebar`).checked || document.querySelector(`#state-switch`).checked))
		{
			const openedElement = document.querySelector(`#sidebar`).checked ? document.querySelector(`#sidebar`) : document.querySelector(`#state-switch`);
			
			trigger(openedElement, `change`, false);
		}
	});

	trigger(window, `resize`);
};
